import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch, useSelector } from "react-redux";
import CommonDrawerLayout from "../../../common_components/CommonDrawerLayout";
import AppButton from "../../../common_components/AppButton";
import { TextInput, NumberInput, TextArea, Dropdown, FormRow, FormField } from "../../../common_components/FormInputs";
import SingleDatePicker from "../../../common_components/daterangepicker/SingleDatePicker";
import { DEAL_TYPE_OPTIONS, EMPTY_DEAL_FORM } from "../utils";
import { toCalendarDate, fromCalendarDate } from "../Component/shared";
import { createDeal, updateDeal, selectDealsSaving } from "../../../redux/salesReportingSlice";
const TYPE_OPTIONS = DEAL_TYPE_OPTIONS.map((t) => ({ value: t.value, label: t.label }));
const SalesReportingDealDrawer = ({ open, onClose, mode, record }) => {
    const dispatch = useDispatch();
    const saving = useSelector(selectDealsSaving);
    const [formData, setFormData] = useState(EMPTY_DEAL_FORM);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (!open)
            return;
        if (mode === "edit" && record) {
            setFormData({
                id: record._id,
                deal_name: record.deal_name || "",
                mrr: record.mrr !== null && record.mrr !== undefined ? String(record.mrr) : "",
                date: record.date ? fromCalendarDate(toCalendarDate(record.date)) : "",
                type: record.type || "",
                notes: record.notes || "",
            });
        }
        else {
            setFormData(EMPTY_DEAL_FORM);
        }
        setErrors({});
    }, [open, mode, record]);
    const setField = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
        setErrors((prev) => ({ ...prev, [field]: "" }));
    };
    const validate = () => {
        // All fields are optional; only validate MRR's format when a value is entered.
        const next = {};
        if (formData.mrr !== "" && (!Number.isFinite(Number(formData.mrr)) || Number(formData.mrr) < 0)) {
            next.mrr = "MRR must be 0 or greater.";
        }
        setErrors(next);
        return Object.keys(next).length === 0;
    };
    const handleSave = async () => {
        if (!validate())
            return;
        const payload = {
            deal_name: formData.deal_name.trim(),
            mrr: formData.mrr === "" ? null : Number(formData.mrr),
            date: formData.date,
            type: formData.type ? formData.type : null,
            notes: formData.notes.trim(),
        };
        const action = mode === "edit" && formData.id
            ? await dispatch(updateDeal({ id: formData.id, payload }))
            : await dispatch(createDeal(payload));
        if (createDeal.fulfilled.match(action) || updateDeal.fulfilled.match(action)) {
            onClose();
        }
    };
    return (_jsx(CommonDrawerLayout, { open: open, onClose: onClose, title: mode === "add" ? "Add Deal" : "Edit Deal", width: "md", className: "sr-deal-drawer", headerActions: _jsx(AppButton, { variant: "contained", color: "primary", startIcon: _jsx(SaveIcon, {}), onClick: handleSave, disabled: saving, children: saving ? "Saving..." : mode === "add" ? "Save" : "Update" }), children: _jsx(Box, { className: "sr-deal-drawer-body", children: _jsxs(Box, { className: "sr-deal-drawer-section", children: [_jsxs(FormRow, { columns: 2, children: [_jsx(FormField, { children: _jsx(TextInput, { label: "Deal Name", placeholder: "Deal Name", value: formData.deal_name, onChange: (e) => setField("deal_name", e.target.value), error: !!errors.deal_name, errorMessage: errors.deal_name }) }), _jsx(FormField, { children: _jsx(NumberInput, { label: "MRR", placeholder: "MRR", value: formData.mrr, onChange: (e) => setField("mrr", e.target.value), min: 0, error: !!errors.mrr, errorMessage: errors.mrr }) })] }), _jsxs(FormRow, { columns: 2, children: [_jsx(FormField, { children: _jsx(SingleDatePicker, { label: "Date", placeholder: "Date", value: toCalendarDate(formData.date), onChange: (d) => setField("date", fromCalendarDate(d)), allowToday: true, maxPastYears: 5, error: !!errors.date, errorMessage: errors.date }) }), _jsx(FormField, { children: _jsx(Dropdown, { label: "Type", value: formData.type, onChange: (v) => setField("type", v), options: TYPE_OPTIONS, placeholder: "Select Type", sortByLabel: false, error: !!errors.type, errorMessage: errors.type }) })] }), _jsx(FormField, { children: _jsx(TextArea, { label: "Notes", placeholder: "Notes", value: formData.notes, onChange: (e) => setField("notes", e.target.value), minRows: 6 }) })] }) }) }));
};
export default SalesReportingDealDrawer;
